import { BreadcrumbItem } from '@portalterreno/react-ui/Breadcrumb';
import React from 'react';

import StyledBreadCrumb from './StyledBreadCrumb';
import Wrapper from './Wrapper';

export type Breadcrumb = {
  breadCrumbItems: Array<BreadcrumbItem>;
};

const Breadcrumb: React.FC<Breadcrumb> = ({ breadCrumbItems, ...rest }) => {
  return (
    <Wrapper {...rest}>
      <StyledBreadCrumb items={breadCrumbItems} />
    </Wrapper>
  );
};

export default React.memo(Breadcrumb);
